module.exports = __webpack_public_path__ + "img/8_Nova_SBE_Picture3.23455755.jpg";